(() => {
  'use strict';
  const script = document.currentScript;
  const labels = { de: script?.dataset.languageDe, en: script?.dataset.languageEn };
  const ownedLabels = new WeakMap();
  let discovery;
  let timeout;
  let root;
  let observer;

  function labelLanguageControls() {
    root?.querySelectorAll('select[name="language"]').forEach(select => {
      const existing = select.getAttribute('aria-label');
      if ((existing && existing !== ownedLabels.get(select))
        || select.getAttribute('aria-labelledby') || select.labels?.length) return;
      const label = labels[select.value.split('-')[0]];
      if (!label || existing === label) return;
      select.setAttribute('aria-label', label);
      ownedLabels.set(select, label);
    });
  }

  function connect() {
    if (root) return;
    const host = document.querySelector('pandectes-cmp[data-active-instance="true"]');
    if (!host?.shadowRoot) return;
    root = host.shadowRoot;
    discovery?.disconnect();
    clearTimeout(timeout);
    labelLanguageControls();
    observer = new MutationObserver(labelLanguageControls);
    observer.observe(root, { childList: true, subtree: true });
    root.addEventListener('change', labelLanguageControls);
  }

  function start() {
    if (root) return;
    discovery?.disconnect();
    clearTimeout(timeout);
    connect();
    if (root) return;
    discovery = new MutationObserver(connect);
    discovery.observe(document.body, { childList: true, subtree: true });
    timeout = setTimeout(() => discovery.disconnect(), 15000);
  }

  window.addEventListener('pagehide', () => {
    discovery?.disconnect();
    observer?.disconnect();
    clearTimeout(timeout);
    root?.removeEventListener('change', labelLanguageControls);
    root = undefined;
  });
  window.addEventListener('pageshow', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
